<template>
  <div>
    <p class="adminSubheader mb-5">Administradores ativos</p>
    <AdminListItem
      v-for="admin in admins"
      :key="admin._id"
      :id="admin._id"
      :name="admin.name"
      :email="admin.email"
      :phone="admin.phone"
    />
  </div>
</template>

<script>
import AdminListItem from "@/components/molecules/Administrador/admin-list-item";
export default {
  components: {
    AdminListItem
  },
  computed: {
    admins() {
      return this.$store.getters.adminAccounts;
    }
  }
};
</script>

<style scoped>
.adminSubheader {
  font-family: "Montserrat", sans-serif;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.16px;
  font-feature-settings: "pnum" on, "lnum" on;
  color: #9e9e9e;
}
</style>